import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, CircularProgress } from "@mui/material";
import totalStudentsIcon from "../../assets/images/Student.svg";
import totalTutorsIcon from "../../assets/images/tutor.svg";
import awaitingFollowupIcon from "../../assets/images/waitingUser.svg";
import conversionIcon from "../../assets/images/Userswap.svg";
import axios from "axios";
import CrmStatusCard from "../../Componenets/StatusCard/CrmStatusCard";
import LeadsBySourceChart from "../../Componenets/Charts/LeadsBySourceChart";
import TopTutorsBarChart from "../../Componenets/Charts/TopTUtorChat";
import ActivityFeed from "../../../Pages/AdminDashboard/ActivityFeed";

const CRMDashboard = () => {
  //   const [dashboardData, setDashboardData] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const dashboardData = {
    stats: [
      { title: "Total Students", value: 102, trend: 40, index: 1 },
      { title: "Total Tutors", value: 98, trend: 0, index: 2 },
      { title: "Awaiting Follow-up", value: 12, trend: -12, index: 3 },
      { title: "Conversion", value: 65, trend: 19, index: 4 },
    ],

    leadsBySource: [
      { name: "Facebook", value: 20 },
      { name: "GoogleAds", value: 30 },
      { name: "Website", value: 50 },
    ],
    topTutors: [
      { name: "John Smith", performance: 95 },
      { name: "Anna Marry", performance: 93 },
      { name: "Priya K", performance: 90 },
      { name: "George David", performance: 85 },
      { name: "Harry Porter", performance: 80 },
    ],
    activities: [
      {
        id: 1,
        title: "Test Completed",
        description: "Maya Singh | Math Test – Score: 92%",
        time: "2025-10-10 | 09:30",
      },
      {
        id: 2,
        title: "New User Registered",
        description: "Arjun Mehta | Manually Added (Free)",
        time: "2025-10-10 | 09:30",
      },
      {
        id: 3,
        title: "Payment Made",
        description: "Kavya Reddy | Paid Subscription – ₹799",
        time: "2025-10-10 | 09:30",
      },
      {
        id: 4,
        title: "New User Registered",
        description: "Arjun Mehta | Manually Added (Free)",
        time: "2025-10-10 | 09:30",
      },
      {
        id: 5,
        title: "Payment Made",
        description: "Kavya Reddy | Paid Subscription – ₹799",
        time: "2025-10-10 | 09:30",
      },
    ],
  };

  const iconMap: Record<string, React.ReactNode> = {
    "Total Students": (
      <img
        src={totalStudentsIcon}
        alt="Total Students"
        width={24}
        height={24}
      />
    ),
    "Total Tutors": (
      <img src={totalTutorsIcon} alt="Total Tutors" width={24} height={24} />
    ),
    "Awaiting Follow-up": (
      <img
        src={awaitingFollowupIcon}
        alt="Awaiting Follow-up"
        width={24}
        height={24}
      />
    ),
    Conversion: (
      <img src={conversionIcon} alt="Conversion" width={24} height={24} />
    ),
  };

  const colorMap: Record<string, string> = {
    "Total Students": "#8B5CF6",
    "Total Tutors": "#06B6D4",
    "Awaiting Follow-up": "#F59E0B",
    Conversion: "#10B981",
  };

  //   useEffect(() => {
  //     const fetchDashboard = async () => {
  //       try {
  //         const response = await axios.get("/api/dashboard");
  //         setDashboardData(response.data);
  //       } catch (err) {
  //         console.error("Failed to load dashboard data", err);
  //       } finally {
  //         setLoading(false);
  //       }
  //     };
  //     fetchDashboard();
  //   }, []);

  if (loading)
    return (
      <Box p={5} display="flex" justifyContent="center" alignItems="center">
        <CircularProgress />
      </Box>
    );

  if (!dashboardData)
    return (
      <Box p={5}>
        <Typography color="error">Failed to load dashboard data.</Typography>
      </Box>
    );

  const generateChartData = (trend: number, value: number, index: number) => {
    const points = 40;
    const base = value;
    const amplitude = Math.max(Math.abs(trend) * 0.8, 1.5);
    const freq = 0.5 + index * 0.15; // unique frequency per card

    return Array.from({ length: points }, (_, i) => ({
      value:
        base +
        Math.sin(i * freq + index) * amplitude +
        Math.cos(i * 0.4 + index * 0.7) * (amplitude / 2) +
        (Math.random() - 0.5) * amplitude * 0.3,
    }));
  };

  return (
    <Box p={2}>
      <Typography variant="h6" fontWeight={600} mb={2}>
        Dashboard
      </Typography>

      {/* Stats Cards */}
      <Grid container spacing={2} mb={3}>
        {dashboardData.stats.map((item: any) => (
          <Grid item xs={12} sm={6} md={3} key={item.title}>
            <CrmStatusCard
              title={item.title}
              value={item.value}
              trend={item.trend}
              color={colorMap[item.title]}
              icon={iconMap[item.title]}
              chartData={generateChartData(item.trend, item.value, item.index)}
              onViewAll={() => alert(`View all ${item.title}`)}
            />
          </Grid>
        ))}
      </Grid>

      {/* Charts + Recent Activity */}
      <Grid container spacing={2}>
        {/* Left Column */}
        <Grid item xs={12} md={8}>
          <Grid container spacing={2} direction="column">
             <Grid item>
              <LeadsBySourceChart data={dashboardData.leadsBySource} />
            </Grid>
            <Grid item>
              <TopTutorsBarChart data={dashboardData.topTutors} />
            </Grid>
          </Grid>
        </Grid>

        {/* Right Column */}
        <Grid item xs={12} md={4}>
          <ActivityFeed items={dashboardData.activities} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CRMDashboard;
